import lodash from "lodash";
import { camelize } from "humps";
import purchaseModeGrouping from "../../../configs/purchaseModeGrouping.json";

export const COMPOSED_KEY_SEPARATOR = "_";

export class PurchaseModeOffer {
	constructor({
		id,
		purchaseMode,
		sapCode,
		stockStatus,
		physicalStockStatus,
		hasStock,
		hasPhysicalStock,
		priceOffers
	}) {
		this.id = id;
		this.purchaseMode = camelize(purchaseMode);
		this.sapCode = sapCode;

		this.stockStatus = stockStatus;
		this.physicalStockStatus = physicalStockStatus;
		this.hasStock = hasStock;
		this.hasPhysicalStock = hasPhysicalStock;

		// List of priceOfferIds
		this.priceOffers = priceOffers;
	}

	getPurchaseModeGroup() {
		return PurchaseModeOffer.getPurchaseModeGroupByPurchaseMode(
			this.purchaseMode
		);
	}

	static findMatchingPurchaseModeOfferId(purchaseMode, purchaseModeOfferIds) {
		return purchaseModeOfferIds.find(
			(id) => id.split(COMPOSED_KEY_SEPARATOR)[0] == camelize(purchaseMode)
		);
	}

	static getPurchaseModeGroupByPurchaseMode(purchaseMode) {
		const key = lodash.findKey(purchaseModeGrouping, (groupArray) =>
			groupArray.includes(camelize(purchaseMode))
		);
		if (!key) {
			return null;
		}
		return key;
	}

	static getPurchaseModesByGroup(purchaseModeGroup) {
		return purchaseModeGrouping ? purchaseModeGrouping[purchaseModeGroup] : null;
	}

	static getPurchaseModeGrouping() {
		return purchaseModeGrouping;
	}

	static getPurchaseModeOffer(
		purchaseMode,
		purchaseModeOfferIds,
		purchaseModeOffersObj
	) {
		const purchaseModeOfferId = PurchaseModeOffer.findMatchingPurchaseModeOfferId(
			purchaseMode,
			purchaseModeOfferIds
		);

		if (!purchaseModeOfferId) {
			// E.g. There is no offer for the currently selected PurchaseMode
			return null;
		}

		const purchaseModeOffer = new PurchaseModeOffer(
			purchaseModeOffersObj.byId[purchaseModeOfferId]
		);

		if (purchaseModeOffer && purchaseModeOffer.priceOffers.length > 0) {
			return purchaseModeOffer || null;
		}
	}

	static getFirstPurchaseModeOffer(purchaseModeOfferIds, purchaseModeOffersObj) {
		let purchaseModeOffer = null;

		if (purchaseModeOfferIds && purchaseModeOffersObj) {
			purchaseModeOffer = purchaseModeOffersObj.byId[purchaseModeOfferIds[0]];
		}

		return purchaseModeOffer;
	}

	static getNearestFirstPurchaseModeOffer(
		purchaseMode,
		purchaseModeOfferIds,
		purchaseModeOffers
	) {
		let purchaseModeOffer = PurchaseModeOffer.getPurchaseModeOffer(
			purchaseMode,
			purchaseModeOfferIds,
			purchaseModeOffers
		);
		let groupHasAValidPurchaseMode = false;
		if (!purchaseModeOffer) {
			const purchaseModeGroup = PurchaseModeOffer.getPurchaseModeGroupByPurchaseMode(
				purchaseMode
			);
			const purchaseModes = PurchaseModeOffer.getPurchaseModesByGroup(
				purchaseModeGroup
			);
			if (purchaseModes && purchaseModes.length > 0) {
				groupHasAValidPurchaseMode = !lodash.every(purchaseModes, (pm) => {
					purchaseModeOffer = PurchaseModeOffer.getPurchaseModeOffer(
						pm,
						purchaseModeOfferIds,
						purchaseModeOffers
					);
					return purchaseModeOffer == null;
				});
			}
		}
		if (!groupHasAValidPurchaseMode && !purchaseModeOffer) {
			purchaseModeOffer = PurchaseModeOffer.getFirstPurchaseModeOffer(
				purchaseModeOfferIds,
				purchaseModeOffers
			);
		}
		return purchaseModeOffer;
	}

	static getFirstPriceOfferIdForPurchaseMode(
		purchaseMode,
		purchaseModeOfferIds,
		purchaseModeOffersObj
	) {
		let priceOfferId = null;
		const purchaseModeOffer = PurchaseModeOffer.getPurchaseModeOffer(
			purchaseMode,
			purchaseModeOfferIds,
			purchaseModeOffersObj
		);
		if (purchaseModeOffer) {
			priceOfferId =
				purchaseModeOffer.priceOffers && purchaseModeOffer.priceOffers.length > 0
					? purchaseModeOffer.priceOffers[0]
					: null;
		}
		return priceOfferId;
	}

	static getPriceOfferIdFromPurchaseModeOfferId(purchaseModeOfferId) {
		let id = null;
		if (purchaseModeOfferId) {
			const splitted = purchaseModeOfferId.split(COMPOSED_KEY_SEPARATOR);
			if (splitted && splitted.length == 2) {
				id = splitted[1];
			} else {
				throw Error(
					`[PurchaseModeOffer]: error when splitting the following purchaseModeOfferId: ${purchaseModeOfferId}`
				);
			}
		}
		return id;
	}
}
